import { useQuery } from '@tanstack/react-query';
import { containers } from '../services/api';

// One query/cache for the sidebar, dashboard and lab list. Socket messages
// invalidate this query; they never supply competing or unscoped counters.
export default function useEnvironmentStats(enabled = true) {
  return useQuery({
    queryKey: ['containerStats'], queryFn: () => containers.stats(), enabled,
    refetchInterval: 30000, retry: false,
  });
}
